import { render } from "./_icon-close.vue?vue&type=template&id=4e250d3c"
import script from "./_icon-close.vue?vue&type=script&lang=js"
export * from "./_icon-close.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__